export enum BritamAdminAgencyTab {
    Profile = 'Profile',
    Users = 'Users',
    Quotes = 'Quotes',
    Policies = 'Policies',
    Credit = 'Credit',
    Local_Travel = 'Local travel'
}
